import { slotDefinition } from "slotworks/model/slot-definition";

export function ThemeGameDefinitionSetup(): void {
    slotDefinition.matrixGrid = [3, 3, 3];
    slotDefinition.processSymbols([
        {
            id: "X",
            bonusId: 1,
            scatter: false,
            ways: true,
            wild: true,
            zIndex: 10,
            anticipation: 5,
            matchesMin: 3,
            payouts: {},
            reels: [1, 2, 3]
        }, // 0
        {
            id: "Y",
            bonusId: 2,
            scatter: false,
            ways: true,
            wild: true,
            zIndex: 10,
            anticipation: 5,
            matchesMin: 3,
            payouts: {},
            reels: [1, 2, 3]
        }, // 1
        {
            id: "Z",
            bonusId: 3,
            scatter: false,
            ways: true,
            wild: true,
            zIndex: 10,
            anticipation: 5,
            matchesMin: 3,
            payouts: {},
            reels: [1, 2, 3]
        }, // 2
        { id: "XYZ", payouts: {} }, // 3 // Doesn't show
        { id: "A", payouts: {} }, // 4
        { id: "B", payouts: {} }, // 5
        { id: "C", payouts: {} }, // 6
        { id: "ABC", payouts: {} }, // 7 // Doesn't Show
        { id: "M", payouts: {} }, // 8
        { id: "N", payouts: {} }, // 9
        { id: "MN", payouts: {} }, // 10 // Doesn't Show
        { id: "BL", payouts: {} } // 11 // Blank

    ]);
    slotDefinition.processReelSets({
        base: [ // TODO these are dumb temp reels that need replacing.
            [11, 9, 11, 0, 11, 8, 11, 5, 11, 9, 11, 2, 11, 4, 11, 6, 11, 8, 11, 9, 11, 1, 11, 9, 11, 8, 11, 5, 11, 8, 11, 9, 11, 4, 11, 1, 11, 6, 11, 4, 11, 8, 11, 9, 11, 0, 11, 5, 11, 6, 11, 8, 11, 2, 11, 6],
            [11, 8, 11, 5, 11, 9, 11, 1, 11, 6, 11, 5, 11, 4, 11, 9, 11, 0, 11, 8, 11, 6, 11, 9, 11, 2, 11, 5, 11, 4, 11, 8, 11, 6, 11, 1, 11, 8, 11, 9, 11, 8, 11, 9, 11, 0, 11, 5, 11, 9, 11, 8, 11, 2, 11, 6],
            [11, 9, 11, 8, 11, 6, 11, 1, 11, 9, 11, 8, 11, 5, 11, 6, 11, 0, 11, 9, 11, 6, 11, 4, 11, 2, 11, 8, 11, 5, 11, 4, 11, 9, 11, 1, 11, 8, 11, 9, 11, 4, 11, 9, 11, 0, 11, 8, 11, 6, 11, 5, 11, 2, 11, 8],
        ]
    });
}
